import IRNEWS_CONFIG from './_lib/IRNEWS_CONFIG.js';
import IRNewsList from './_lib/IRNewsList.js';
import IRNewsMenuList from './_lib/IRNewsMenuList.js';
import IRNewsYearList from './_lib/IRNewsYearList.js';

const d = document;

// リスト生成
d.addEventListener('DOMContentLoaded', () => {
  const $list = d.querySelector('.ir_news-list');
  if ($list) {
    const list = new IRNewsList(IRNEWS_CONFIG, $list);

    const $menu = d.querySelector('.ir_news-menu-list');
    if ($menu) {
      new IRNewsMenuList(IRNEWS_CONFIG, $menu, list);
    }

    const $year = d.querySelector('.ir_news-year-list');
    if ($year) {
      new IRNewsYearList(IRNEWS_CONFIG, $year, list);
    }
  }
});
